import { RouterModule, Routes } from '@angular/router';
import { HasPermissionToModuleGuard, ModuleName } from '../subscription-package';
import { StatisticsDashboardComponent } from './statistics-dashboard/statistics-dashboard.component';
import { NgModule } from '@angular/core';
import { PermissionGuard } from '../core/authentication/permission.guard';
import { AuthGuard } from '../core/authentication/auth.guard';
import { StatisticsWorkerAgreementsComponent } from './statistics-worker-agreements/statistics-worker-agreements.component';
import { Permission } from '../common/enums';

const routes: Routes = [
  {
    path: 'statistics',
    component: StatisticsDashboardComponent,
    canActivate: [AuthGuard, PermissionGuard, HasPermissionToModuleGuard],
    data: {
      permissions: [Permission.ManageStatistics],
      moduleName: ModuleName.Statistics,
    },
  },
  {
    path: 'statistics/worker-agreements',
    component: StatisticsWorkerAgreementsComponent,
    canActivate: [AuthGuard, PermissionGuard, HasPermissionToModuleGuard],
    data: {
      permissions: [Permission.ManageStatistics],
      moduleName: ModuleName.Statistics,
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class StatisticsRoutingModule {}
